import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  highlighted: {
    color: theme.palette.secondary.main,
    fontWeight: 700,
    textDecoration: 'none',
  },
}));

const Highlighted: React.FC = ({ children }) => {
  const classes = useStyles();
  return <span className={classes.highlighted}>{children}</span>;
};

export default Highlighted;
